import photo1 from './project23-1.png';
import photo2 from './project23-2.png';
import photo3 from './project23-3.png';
import photo4 from './project23-4.png';
import photo5 from './project23-5.png';
import photo6 from './project23-6.png';
import photo7 from './project23-7.png';
import photo8 from './project23-8.png';

const project23 = {
  id: 23,
  name: 'Weevo',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '이유진, 김남우',
    },
    {
      position: 'BackEnd Developer',
      names: '김예린, 조서정, 정윤아, 박민서',
    },
    {
      position: 'UXUI Designer',
      names: '육초연',
    },
  ],
    about:
    "Weevo는 '직조하다' 라는 뜻의 weave에서 출발한 이름입니다.\n" +
    "서로 다른 재능이 실처럼 얽히고 교차하면서, 학생들 사이의 배움과 교류가 하나의 직조물처럼 완성되기를 바라는 마음을 담았습니다. 이름 속 ‘we’는 함께 배우고, 함께 성장하는 우리를 의미하며, Weevo = We + Evolve라는 해석 또한 가능해 우리의 배움과 변화, 진화를 함축하는 의미도 동시에 담고 있습니다.\n" +
    "이화인들이 가진 재능과 역량을 바탕으로 재능 교환, 재능 공유, 과외, 커피챗 등의 유연한 형식으로 연결되며, 지식과 경험이 ‘일방적 전달’보다 ‘함께 엮는 과정’이 되도록 합니다.",  links: {
    website: 'https://weevo.netlify.app/signIn',
    github: 'https://github.com/EFUB-SWS-Rudolph',
  },
  photos: [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8],
};

export default project23;
